
const YES = "YES";

const SERVER = "/analytics/bootstrap.php";

class Api {

  static async getReportForAdmin(client_id, fromDate, tillDate) {
    return await this.req("GET_REPORT_ADMIN", {
      client_id,
      fromDate,
      tillDate
    });
  }

  static async recordAcitity(code) {
    //alert(CODES.getReadableName(code))
    // console.log(code);

    //return;
    console.log(Api.DO_NOT_RECORD+"DO_NOT_RECORD");
    if(Api.DO_NOT_RECORD===true)
    {
      return ;
    }
    return await this.request("RECORD_ACTIVITY", {
      activity: code
    });
  }

  static async heartBeat() {
    this.request("HEART_BEAT", {});
  }

  static async startSession(accessToken) {
    if(Api.sessionStarted===true)
    {
      return;
    }
    var client_info = {
      timeOpened: new Date(),
      timezone: (new Date()).getTimezoneOffset() / 60,

      pageon: window.location.pathname,
      referrer: document.referrer,
      previousSites: history.length,

      browserName: navigator.appName,
      browserEngine: navigator.product,
      browserVersion1a: navigator.appVersion,
      browserVersion1b: navigator.userAgent,
      browserLanguage: navigator.language,
      browserOnline: navigator.onLine,
      browserPlatform: navigator.platform,
      javaEnabled: navigator.javaEnabled(),
      dataCookiesEnabled: navigator.cookieEnabled,
      sizeScreenW: screen.width,
      sizeScreenH: screen.height,
      sizeDocW: document.width,
      sizeDocH: document.height,
      sizeInW: innerWidth,
      sizeInH: innerHeight,
      sizeAvailW: screen.availWidth,
      sizeAvailH: screen.availHeight,
      scrColorDepth: screen.colorDepth,
      scrPixelDepth: screen.pixelDepth,
    };

    let {
      client_detail,
      RESULT,
      visitor_token,
      visit_id
    } = await this.request("START_SESSION", {
      accessToken,
      client_info
    });
    if (RESULT == "SUCCESS") {
      Api.sessionStarted=true;
      localStorage.setItem("visitor_token", visitor_token);
      localStorage.setItem("visit_id", visit_id);
      setInterval(() => {
        Api.heartBeat();
      }, 30 * 1000);
      return client_detail;
    }
    throw new Error("Invalid Access Token");

  }

  static async generate_token() {
    return await Api.req("GENERATE_UID", {});

  }

  static async login({
    username,
    password
  }) {
    let {
      SUCCESS
    } = await Api.request("LOGIN", {
      username,
      password
    });

    if (SUCCESS != YES) {
      throw new Error("Invalid username or password");
    }
  }

  static async getClientDetailById(client_id) {
    let client_detail = await this.req("CLIENT_DETAIL_BY_ID", {
      client_id
    });
    return client_detail;
  }

  static async doLogout() {
    let {
      SUCCESS
    } = await Api.request("LOG_OUT");
    return SUCCESS;
  }

  static async getAllClients() {
    let clients = await this.req("GET_ALL_CLIENTS");
    //console.log("getAllClients",clients);
    return clients;
  }

  static async checkLogin() {
    let {
      USER,
      SUCCESS
    } = await Api.request("CHECK_LOGIN");
    if (SUCCESS != YES) {
      throw new Error("Invalid username or password");
    } else {

      localStorage.setItem("USER", JSON.stringify(USER));
      return USER;

    }
  }

  /**
   * this is to be called by admin calls only
   * @param {string} ACTION 
   * @param {object} body 
   */
  static async req(ACTION, body = {}) {
    let clientInfo = JSON.parse(localStorage.getItem("USER"));
    body.api_access_token = clientInfo.api_access_token;
    return Api.request(ACTION, body);
  }

  static async removeAllLogs() {
    return await this.req("REMOVE_ALL_ACTS");
  }

  static async recordInternalClick(CODE) {

    await Api.recordAcitity(CODE);
    //alert(CODE);
  }

  static async openLink(CODE, linkWidgetName, link, client) {
    if (CODE == "" || CODE == undefined) {
      alert("code not defined");
      return;
    }

    Api.recordAcitity(CODE).then(() => {

      if (link == "" || link == undefined) {
        alert("Link not defined");
        return;
      }
      link = link.replace("ENTERUSERNAMEHERE", client.client_token);
      link = link.replace("[access code]", client.my_strength_code);
      link = link.replace("[OrgID]", client.orgId);

      //
      //  alert(link);
      // location.replace(link);
      //  location.href = link;
      window.open(link);

    }).catch(err => {
      console.log(err);
    });

  }

  static async getAllActivityForAdmin() {
    return await this.req("GET_ALL_ACTIVITY_RESULT", {});
  }

  static async getActivityByClientForAdmin(ACT) {
    return await this.req("GET_ACTIVITY_BY_CLIENT", {
      ACT
    });
  }

  static async request(ACTION, body = {}) {
    body.ACTION = ACTION;
    body.visitor_token = localStorage.getItem("visitor_token");
    body.visit_id = localStorage.getItem("visit_id");
    let resp = await fetch(SERVER, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(body)
    });
    try {
      if (resp.headers.get("content-length") == "0") {
        throw new Error("Your session has timed out please login again.");
      }

      let val = await resp.json();
      console.log(val);
      return val;
    } catch (e) {
      console.log(e);
      throw e;
    }

  }

}

export default Api;
 